import { useEffect, useRef } from 'react';

export function useInboundRealtimeRefresh(refresh: () => void) {
  const latest = useRef(refresh);
  latest.current = refresh;
  const timer = useRef<number | null>(null);
  useEffect(() => () => {
    if (timer.current !== null) window.clearTimeout(timer.current);
  }, []);
  return (payload: { action?: string; eventType?: string }) => {
    if (timer.current !== null) window.clearTimeout(timer.current);
    timer.current = null;
    if (payload.action || !payload.eventType?.startsWith('Workflow')) {
      latest.current();
      return;
    }
    timer.current = window.setTimeout(() => {
      timer.current = null;
      latest.current();
    }, 1000);
  };
}